var map = {
	"./logo_deliveroo.png": "ab5d",
	"./logo_glovo.png": "8687",
	"./logo_justeat.png": "63b2",
	"./logo_shargo.png": "16bf",
	"./logo_shop.png": "3d87",
	"./logo_stuart.png": "56b1",
	"./logo_uber.png": "6290"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f92";